"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useOptionsPicker = (params) => {
    const [opened, setOpened] = (0, react_1.useState)(false);
    const open = () => {
        setOpened(true);
        if (!opened) {
            params?.onOpen?.();
        }
    };
    const close = () => {
        setOpened(false);
        if (opened) {
            params?.onClose?.();
        }
    };
    return { isOpen: opened, open, close };
};
exports.default = useOptionsPicker;
